export default __webpack_public_path__ + "static/media/cx_cover_jcs1.edb14c0f.jpg";